const sanitizeRut = _str_ => {
    return typeof _str_ === "string"
        ? _str_.replace(/^0+|[^0-9kK]+/g, "").toUpperCase()
        : "";
};

const formatRut = _rut_ => {
    if (typeof _rut_ === 'number') {
        _rut_ = _rut_.toString();
    }
    let result;
    if (_rut_) {
        const rut = sanitizeRut(_rut_);
        result = `${rut.slice(-4, -1)}-${rut.substr(rut.length - 1)}`;
        for (let i = 4; i < rut.length; i += 3) {
            result = `${rut.slice(-3 - i, -i)}.${result}`;
        }
    }
    return result;
};

const clean = _str_ => {
    return typeof _str_ === "string"
        ? _str_.replace(/^0+|[^0-9kK]+/g, "").toUpperCase()
        : "";
};

const isValidRut = _str => {
    let str = _str;
    if (typeof str !== "string") return false;
    str = clean(str).toUpperCase();
    let t = parseInt(str.slice(0, -1), 10);
    let m = 0;
    let s = 1;
    while (t > 0) {
        s = (s + (t % 10) * (9 - (m % 6))) % 11;
        m += 1;
        t = Math.floor(t / 10);
    }
    const v = s > 0 ? `${s - 1}` : "K";
    return v === str.slice(-1);
};

const isValidSerialNumber = (_serialNumber, _isLiveValidation = false) => {
    const unmaskedSerialNumber = _serialNumber.replace(/\./g, "");
    if (_isLiveValidation) return /^[a-zA-Z0-9]{1,11}$/.test(unmaskedSerialNumber);
    return /^[a-zA-Z0-9]{9,11}$/.test(unmaskedSerialNumber);
};

const formatSerialNumber = _serialNumber => {
    const cleanSerial = _serialNumber.replace(/[^a-zA-Z0-9]/g, "").slice(0, 11);
    return cleanSerial.replace(/(.{3})(?=.)/g, "$1.");
};



const formatThousandsSeparators = (word) => {
    try {
        const formatePuntos = word
            .toString()
            .replace(/\./g, '')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const formateThousandsSeparators = formatePuntos;
        return formateThousandsSeparators;
    } catch (error) {
        return '';
    }
}

const agregarformatoPesos = (numero) => {
    try {
        return `${formatThousandsSeparators(numero)}`
    } catch (error) {
        return ''
    }
}


const validarEmail = (valor) => {
    let valido;
    const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regExp.test(valor)) {
        valido = true
    } else {
        valido = false
    }
    return valido;
}


const capitalize = (word) => {
    return word
        .toLowerCase()
        .replace(/\w/, firstLetter => firstLetter.toUpperCase());
}

const capitalizeEachWord = (cadena) => {
    const arr = cadena.split(" ");
    for (let i = 0; i < arr.length; i += 1) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
    }
    return arr.join(" ");
}

const fechayHora = (fecha) => {
    const arr = fecha.split('/');
    const mesArr = arr[1]
    let mes;
    switch (mesArr) {
        case '01':
            mes = 'Enero';
            break;
        case '02':
            mes = 'Febrero';
            break;
        case '03':
            mes = 'Marzo';
            break;
        case '04':
            mes = 'Abril';
            break;
        case '05':
            mes = 'Mayo';
            break;
        case '06':
            mes = 'Junio';
            break;
        case '07':
            mes = 'Julio';
            break;
        case '08':
            mes = 'Agosto';
            break;
        case '09':
            mes = 'Septiembre';
            break;
        case '10':
            mes = 'Octubre';
            break;
        case '11':
            mes = 'Noviembre';
            break;
        case '12':
            mes = 'Diciembre';
            break;
        default:
            break;
    }

    const fechayHoraParseado = `${arr[0]} de ${mes} ${arr[2]} `;
    
    return fechayHoraParseado;

}

const obtieneNombreApellidos = (nombres, apellidoPaterno, apellidoMaterno) => {
    const splitNombres = nombres.split(" ");
    const nombre = capitalize(splitNombres[0]);
    apellidoPaterno = capitalize(apellidoPaterno);
    apellidoMaterno = capitalize(apellidoMaterno);
    return `${nombre} ${apellidoPaterno} ${apellidoMaterno}`;
}

const codigoAplicacion = 'SDTC';

export { formatRut, isValidRut, isValidSerialNumber, formatSerialNumber, agregarformatoPesos, validarEmail, capitalize, capitalizeEachWord, fechayHora, obtieneNombreApellidos, codigoAplicacion };